import React, { FC, useEffect } from 'react';
import { VStack } from '@chakra-ui/react';
import EnterAmountCard from '@app/screens/liquidity/AddLiquidityV3/components/EnterAmountsCard';
import { Currency, Field } from '@cryptoalgebra/kim-sdk';
import { useMintActionHandlers, useMintState } from '@app/state/mintStore';

interface Props {
  currencyA: Currency | undefined;
  currencyB: Currency | undefined;
  mintInfo: any;
}

export const AmountsInput: FC<Props> = ({ currencyA, currencyB, mintInfo }) => {
  const { independentField, typedValue } = useMintState();

  const { onFieldAInput, onFieldBInput } = useMintActionHandlers(false);

  const formattedAmounts = {
    [independentField]: typedValue,
    [mintInfo.dependentField]:
      mintInfo.parsedAmounts[mintInfo.dependentField]?.toSignificant(6) ?? ''
  };

  useEffect(() => {
    return () => {
      onFieldAInput('');
      onFieldBInput('');
    };
  }, [onFieldAInput, onFieldBInput]);

  return (
    <>
      <VStack w="100%">
        <EnterAmountCard
          currency={currencyA}
          value={formattedAmounts[Field.CURRENCY_A]}
          handleChange={value => onFieldAInput(value)}
          isDisabled={mintInfo.depositADisabled}
        />
      </VStack>
      <VStack w="100%">
        <EnterAmountCard
          currency={currencyB}
          value={formattedAmounts[Field.CURRENCY_B]}
          handleChange={value => onFieldBInput(value)}
          isDisabled={mintInfo.depositBDisabled}
        />
      </VStack>
    </>
  );
};
